import React from 'react'

import Editor from 'src/editor/containers/Editor/Editor'
import { OrderLine, Props as EditorProps } from 'src/editor/types'
import CardCatalog from 'src/catalog/containers/CardCatalog'
import { FullWindowModal } from 'src/chrome'
import { useState } from 'src/hooks'
import { CardFragment } from 'src/graphql'

import { CatalogSubroute } from 'src/catalog/routes/CatalogRoute'

type Props = {
  onClose?: () => void
  context: {
    headerText?: string
    headerSubText?: string
    lines?: OrderLine[]
    activeCardId?: string
    footerLabel: (card: CardFragment) => JSX.Element
  }
  editorSecondaryAction?: ({
    closeEditor,
  }: {
    closeEditor: () => void
  }) => EditorProps['secondaryAction']
  onAfterSave: (cardId: string) => Promise<void>
  saveButtonLabel: EditorProps['saveButtonLabel']
  onCatalogNavigate: (subroute?: CatalogSubroute) => void
  catalogSubroute: CatalogSubroute | undefined
}

const CardPicker: React.SFC<Props> = props => {
  const {
    context,
    onClose,
    onAfterSave,
    saveButtonLabel,
    onCatalogNavigate,
    catalogSubroute,
    editorSecondaryAction,
  } = props

  const [cardId, setCardId] = useState<string | undefined>()

  if (cardId) {
    return (
      <FullWindowModal isReallyFull={true}>
        <Editor
          context={context}
          cardId={cardId}
          onAfterSave={() => onAfterSave(cardId)}
          onClose={() => setCardId(undefined)}
          saveButtonLabel={saveButtonLabel}
          secondaryAction={editorSecondaryAction?.({
            closeEditor: () => setCardId(undefined),
          })}
        />
      </FullWindowModal>
    )
  }

  return (
    <CardCatalog
      onNavigate={onCatalogNavigate}
      context={context}
      onCancel={onClose}
      onSelect={setCardId}
      subroute={catalogSubroute}
    />
  )
}

export default CardPicker
